// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { MUST_BE_NUMERICAL_VALUE } from 'errors'

import {
  isWithinMinMaxVals,
  stringIsNumber,
} from 'validators/common'

const validateAntennaGain = (gain, error) => {
  if (!gain) {
    return
  } else if (!stringIsNumber(gain)) {
    error.gain = MUST_BE_NUMERICAL_VALUE
  } else if (!isWithinMinMaxVals(gain, 0, 100)) {
    error.gain = 'Must be between 0 and 100.'
  }
}

export default validateAntennaGain
